import { FC } from 'react';
import styled from 'styled-components';
import Logo from 'components/atoms/icons/Logo';
import Link from 'next/link';
import ROUTES from 'lib/constants/routes';
import BREAKPOINTS from 'lib/constants/breakpoints';
import COLORS from '@lib/constants/colors';
import useIsAppWebView from '@lib/hooks/useIsAppWebView';

const Wrapper = styled.nav<{ hasBorder: boolean }>`
  display: flex;
  height: 80px;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0 16px;
  z-index: 9;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  border-bottom: ${({ hasBorder }) =>
    hasBorder ? '1px solid rgb(218, 218, 218)' : 'none'};
  background-color: rgb(255, 255, 255);

  @media (max-width: ${BREAKPOINTS.medium}) {
    height: 50px;
    position: relative;
  }
`;

const Inner = styled.div`
  max-width: 1170px;
  display: flex;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0 16px;
  width: 100%;
`;

const StyledLogo = styled(Logo)`
  height: 24px;
`;

const CenterWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 100%;
  left: 50%;
  top: 0px;
  transform: translateX(-50%);
`;

const SimpleNavBar: FC<{
  hasBorder?: boolean;
  className?: string;
  leftComponent?: React.ReactNode;
  rightComponent?: React.ReactNode;
  centerComponent?: React.ReactNode;
  pastel?: boolean;
}> = ({
  hasBorder = false,
  children,
  className,
  leftComponent = (
    <Link href={ROUTES.root}>
      <a>
        <StyledLogo />
      </a>
    </Link>
  ),
  rightComponent,
  centerComponent,
  pastel,
}) => {
  const isAppWebView = useIsAppWebView();

  if (isAppWebView) return null;

  return (
    <Wrapper
      style={{ backgroundColor: pastel ? COLORS.pastel : undefined }}
      hasBorder={hasBorder}
      className={className}
    >
      <Inner>
        {leftComponent}
        {centerComponent && <CenterWrapper>{centerComponent}</CenterWrapper>}
        <div>{rightComponent || children}</div>
      </Inner>
    </Wrapper>
  );
};

export default SimpleNavBar;
